import XERODashboard from './XERODashboard'

export default XERODashboard